import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MessagePreview from '../restaurants/MessagePreview';
import CouponPreview from '../restaurants/CouponPreview';
import './TextMessageFormTwoStyle.css';
import { useDropzone } from 'react-dropzone';
import debounce from 'lodash/debounce';
import { useContext } from 'react';
import { CreditsContext } from '../restaurants/Home';
const MAX_MESSAGE_LENGTH = 160;
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

function TextMessageFormTwoOpti() {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    scheduledDate: new Date(),
    recurrence: 'none',
    selectedRecipients: [],
    // expirationDate: '',
    expirationDays: '', // New field for expiration days

    messageType: 'text',
    image: null,
  });
  const [customers, setCustomers] = useState([]);
  const [optOutWord, setOptOutWord] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [allSelected, setAllSelected] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [messageStatus, setMessageStatus] = useState('');

  const { restaurantId, messageId, action } = useParams();
  const navigate = useNavigate();
  const { refreshCredits } = useContext(CreditsContext);

  // const calculateExpirationDate = (days) => {
  //   if (!days || isNaN(parseInt(days))) return null;
  //   const date = new Date();
  //   date.setDate(date.getDate() + parseInt(days));
  //   return date;
  // };

  const calculateExpirationDate = (days, scheduledDate) => {
    if (!days || isNaN(parseInt(days))) return null;
    const date = new Date(scheduledDate);
    date.setDate(date.getDate() + parseInt(days));
    return date;
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0]) {
      setFormData((prev) => ({ ...prev, image: acceptedFiles[0] }));
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
    },
    multiple: false,
  });

  const handleInputChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const handleDateChange = useCallback(
    (date) => {
      const now = new Date();
      if (date < now) {
        now.setMinutes(now.getMinutes() + 1);
        now.setSeconds(0);
        now.setMilliseconds(0);
        handleInputChange('scheduledDate', now);
      } else {
        handleInputChange('scheduledDate', date);
      }
    },
    [handleInputChange]
  );

  const handleMessageTypeChange = useCallback((type) => {
    setFormData((prev) => ({
      ...prev,
      messageType: type,
      // expirationDate: type === 'text' ? '' : prev.expirationDate,
      expirationDays: type === 'text' ? '' : prev.expirationDays,
    }));
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      const [customersResponse, restaurantResponse] = await Promise.all([
        api.get(`/restaurants/${restaurantId}/subscribers`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        api.get(`/restaurants/${restaurantId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      if (Array.isArray(customersResponse.data.customers)) {
        const allCustomers = customersResponse.data.customers;
        setCustomers(allCustomers);

        if (messageId) {
          const messageResponse = await api.get(
            `/restaurants/${restaurantId}/messages/${messageId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const message = messageResponse.data.messages;
          const coupon = messageResponse.data.coupon;

          // console.log(coupon);
          setFormData((prev) => ({
            ...prev,
            content: message.content,
            title: message.title,
            scheduledDate: new Date(message.scheduledDate),
            recurrence: message.recurrence,
            selectedRecipients: message.recipients,
            messageType: message.messageType || 'text',
            image: message.imageUrl || null,
            // expirationDate: coupon?.expirationDate
            //   ? new Date(coupon.expirationDate).toISOString().split('T')[0]
            //   : message?.expirationDate
            //   ? new Date(message.expirationDate).toISOString().split('T')[0]
            //   : '',
            expirationDays: message?.expirationDays || '', // Add this line
          }));

          //   my code here

          if (
            // message.messageType === 'sendagain' ||
            // message.messageType === 'scheduled'
            action !== 'view'
          ) {
            const now = new Date();
            if (new Date(message.scheduledDate) < now) {
              // If selected time is in the past, set it to current time rounded up to the next minute
              now.setMinutes(now.getMinutes() + 1);
              now.setSeconds(0);
              now.setMilliseconds(0);
              // setScheduledDate(now);
              setFormData((prev) => ({
                ...prev,
                scheduledDate: now,
              }));
              // setPrevScheduledDate(now);
            } else {
              setFormData((prev) => ({
                ...prev,
                scheduledDate: new Date(message.scheduledDate),
              })); // setPrevScheduledDate(new Date(message.scheduledDate));
            }
          } else {
            setFormData((prev) => ({
              ...prev,
              scheduledDate: new Date(message.scheduledDate),
            })); // setPrevScheduledDate(new Date(message.scheduledDate));
          }
          // my code here ends

          setMessageStatus(message.status);
          setAllSelected(message.recipients.length === allCustomers.length);
        } else {
          setFormData((prev) => ({
            ...prev,
            selectedRecipients: allCustomers.map((customer) => customer._id),
          }));
          setAllSelected(true);
        }
      } else {
        console.error(
          'Received non-array data for customers:',
          customersResponse.data
        );
        setCustomers([]);
        setFormData((prev) => ({ ...prev, selectedRecipients: [] }));
        setAllSelected(false);
      }
      setOptOutWord(restaurantResponse.data.optOutWord);
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to fetch data. Please try again.');
    }
  }, [restaurantId, messageId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (formData.messageType === 'coupon' && formData.expirationDays) {
      const newExpirationDate = calculateExpirationDate(
        formData.expirationDays,
        formData.scheduledDate
      );
      // You can use this newExpirationDate to update your state or perform any other necessary actions
      console.log('New expiration date:', newExpirationDate);
    }
  }, [formData.scheduledDate, formData.expirationDays, formData.messageType]);

  const handleAllSubscribersChange = useCallback(
    (e) => {
      const isChecked = e.target.checked;
      setAllSelected(isChecked);
      setFormData((prev) => ({
        ...prev,
        selectedRecipients: isChecked
          ? customers.map((customer) => customer._id)
          : [],
      }));
    },
    [customers]
  );

  const handleSubscriberSelect = useCallback(
    (subscriberId) => {
      setFormData((prev) => {
        const newSelection = prev.selectedRecipients.includes(subscriberId)
          ? prev.selectedRecipients.filter((id) => id !== subscriberId)
          : [...prev.selectedRecipients, subscriberId];
        setAllSelected(newSelection.length === customers.length);
        return { ...prev, selectedRecipients: newSelection };
      });
    },
    [customers]
  );

  const filteredCustomers = useMemo(
    () =>
      customers.filter((customer) => customer.phoneNumber.includes(searchTerm)),
    [customers, searchTerm]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    if (
      !formData.content.trim() ||
      !formData.scheduledDate ||
      formData.selectedRecipients.length === 0
    ) {
      setError(
        'Please fill in all required fields and select at least one recipient'
      );
      setIsSubmitting(false);
      return;
    }

    try {
      const messageData = {
        ...formData,
        restaurantId,
        originalMessageId: messageId,
        existingImageKey:
          formData.image && !formData.image.name
            ? formData.image.split('/').pop()
            : null,
        expirationDays:
          formData.messageType === 'coupon' ? formData.expirationDays : null,
      };

      if (formData.image instanceof File) {
        messageData.image = formData.image;
      } else if (typeof formData.image === 'string') {
        messageData.existingImageUrl = formData.image;
      }

      const token = localStorage.getItem('ownerToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      };

      if (messageId) {
        if (messageStatus === 'sent' || messageStatus === 'failed') {
          await api.post(
            `/restaurants/${restaurantId}/messages/${messageId}/resend`,
            messageData,
            { headers }
          );
          toast.success('Message scheduled to send again');
        } else if (messageStatus === 'scheduled') {
          await api.patch(
            `/restaurants/${restaurantId}/messages/${messageId}`,
            messageData,
            { headers }
          );
          toast.success('Scheduled message updated successfully');
        }
      } else {
        await api.post(`/restaurants/${restaurantId}/messages/`, messageData, {
          headers,
        });
        toast.success('New message scheduled successfully');
      }
      refreshCredits();

      navigate(`/restaurant/${restaurantId}/text-messages`);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Error processing text message';

      if (errorMessage.includes('Insufficient credits')) {
        const match = errorMessage.match(/Required: (\d+), Available: (\d+)/);
        if (match) {
          const [, required, available] = match;
          setError(
            `Insufficient credits. You need ${required} credits but only have ${available} credits available.`
          );
          toast.error(
            `Insufficient credits. You need ${required} credits but only have ${available} credits available.`
          );
        } else {
          setError(errorMessage);
          toast.error(errorMessage);
        }
      } else {
        setError(errorMessage);
        toast.error(errorMessage);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const debouncedSearch = useMemo(
    () => debounce((value) => setSearchTerm(value), 300),
    []
  );

  return (
    <div className='max-w-4xl mx-auto mt-10 px-4'>
      <h2 className='text-2xl font-bold mb-4'>
        {messageId
          ? action === 'view'
            ? 'View Message'
            : messageStatus === 'sent'
            ? 'Send New Message Using This Template'
            : 'Edit Message'
          : 'Create New Message'}
      </h2>
      {/* <div className='flex flex-col md:flex-row md:space-x-8'> */}
      <div className='flex flex-wrap gap-6 space-y-8'>
        <form
          onSubmit={handleSubmit}
          className='space-y-4 flex-1 min-w-[230px]'
        >
          {/* Form fields */}
          <div className='mt-4'>
            <label className='block text-sm font-medium text-gray-700'>
              Title
            </label>
            <textarea
              id='title'
              value={formData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              required
              rows='1'
              placeholder='Enter title..'
              className='w-full p-2 rounded border'
              maxLength={MAX_MESSAGE_LENGTH}
            />
          </div>
          <div>
            <div className='flex justify-between'>
              <label
                htmlFor='content'
                className='block text-sm font-medium text-gray-700'
              >
                Message/Coupon Content
              </label>
              <div className='text-right text-sm text-gray-500'>
                {formData.content.length}/{MAX_MESSAGE_LENGTH}
              </div>
            </div>
            <textarea
              id='content'
              value={formData.content}
              onChange={(e) => handleInputChange('content', e.target.value)}
              required
              rows='4'
              className='w-full p-2 rounded border'
              maxLength={MAX_MESSAGE_LENGTH}
            />
          </div>
          <div>
            <label
              htmlFor='scheduledDate'
              className='block text-sm font-medium text-gray-700'
            >
              Scheduled Date
            </label>
            <DatePicker
              selected={formData.scheduledDate}
              wrapperClassName='w-full'
              onChange={handleDateChange}
              showTimeSelect
              timeIntervals={5}
              timeFormat='HH:mm'
              dateFormat='MMMM d, yyyy h:mm aa'
              minDate={new Date()}
              className='mt-1 p-2 block w-full rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 border'
            />
          </div>
          <div className='mb-4'>
            <label className='block text-sm font-medium text-gray-700'>
              Recurrence
            </label>
            <select
              value={formData.recurrence}
              onChange={(e) => handleInputChange('recurrence', e.target.value)}
              className='w-full p-2 border rounded'
            >
              <option value='none'>None</option>
              <option value='daily'>Daily</option>
              <option value='weekly'>Weekly</option>
              <option value='monthly'>Monthly</option>
            </select>
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700'>
              Recipients
            </label>
            <div className='mt-2'>
              <label className='inline-flex items-center'>
                <input
                  type='checkbox'
                  className='form-checkbox'
                  checked={allSelected}
                  onChange={handleAllSubscribersChange}
                />
                <span className='ml-2'>All Subscribers</span>
              </label>
            </div>
          </div>
          <div className='mt-4'>
            <label className='block text-sm font-medium text-gray-700'>
              Select Subscribers
            </label>
            <input
              type='text'
              placeholder='Search phone number...'
              onChange={(e) => debouncedSearch(e.target.value)}
              className='w-full p-2 border rounded mb-2'
            />
            <div className='border border-gray-300 rounded-md min-h-[120px]'>
              <div className='max-h-[120px] overflow-y-scroll p-2 scz'>
                {filteredCustomers.map((subscriber) => (
                  <div key={subscriber._id} className='flex items-center py-1'>
                    <input
                      type='checkbox'
                      id={`subscriber-${subscriber._id}`}
                      checked={formData.selectedRecipients.includes(
                        subscriber._id
                      )}
                      onChange={() => handleSubscriberSelect(subscriber._id)}
                      className='h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded'
                    />
                    <label
                      htmlFor={`subscriber-${subscriber._id}`}
                      className='ml-2 block text-sm text-gray-900'
                    >
                      {subscriber.phoneNumber}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700'>
              Message Type:
            </label>
            <div className='mt-2'>
              <label className='inline-flex items-baseline mr-4'>
                <input
                  type='radio'
                  value='text'
                  checked={formData.messageType === 'text'}
                  onChange={() => handleInputChange('messageType', 'text')}
                  className='form-radio'
                />
                <span className='ml-2'>Text</span>
              </label>
              <label className='block text-sm font-medium text-gray-400'>
                Send news, promo code, or events.
              </label>
              <label className='inline-flex items-baseline'>
                <input
                  type='radio'
                  value='coupon'
                  checked={formData.messageType === 'coupon'}
                  //   onChange={() => handleInputChange('messageType', 'coupon')}

                  onChange={() => handleMessageTypeChange('coupon')}
                  className='form-radio'
                />
                <span className='ml-2'>Text + Coupon</span>
              </label>
              <label className='block text-sm font-medium text-gray-400'>
                Generate unique one-time coupon for each subscriber.
              </label>
            </div>
          </div>
          {/* <div className='mb-4'>
            <label className='block text-sm font-medium text-gray-700'>
              Coupon Expiration Date (Optional):
            </label>
            <input
              type='date'
              className='w-full p-2 border border-gray-300 rounded'
              value={
                formData.messageType === 'text' ? '' : formData.expirationDate
              }
              onChange={(e) =>
                handleInputChange('expirationDate', e.target.value)
              }
              disabled={formData.messageType !== 'coupon'}
            />
          </div> */}
          {/* ======================================= */}
          {/* <label className='block text-sm font-medium text-gray-700'>
              Coupon Expiration:
            </label> */}
          {/* <div className='mb-4'>
            <div className='flex max-sm:flex-wrap gap-1'>
              <div className=''>
                <label className='block text-sm font-medium text-gray-700 text-nowrap'>
                  Coupon Expiration Date:
                </label>
                <input
                  type='date'
                  className='w-full p-2 border border-gray-300 rounded'
                  value={
                    formData.messageType === 'text'
                      ? ''
                      : formData.expirationDate
                  }
                  onChange={(e) =>
                    handleInputChange('expirationDate', e.target.value)
                  }
                  disabled={formData.messageType !== 'coupon'}
                /> */}
          {/* <DatePicker
                  selected={
                    formData.expirationDate
                      ? new Date(formData.expirationDate)
                      : null
                  }
                  value={
                    formData.messageType === 'text'
                      ? ''
                      : formData.expirationDate
                  }
                  // onChange={handleExpirationDateChange}
                  onChange={(e) =>
                    handleInputChange('expirationDate', e.target.value)
                  }
                  minDate={formData.scheduledDate}
                  className='w-full p-2 border border-gray-300 rounded'
                  dateFormat='yyyy-MM-dd'
                  disabled={formData.messageType !== 'coupon'}
                /> */}
          {/* {formData.expirationDate && (
                  <button
                    type='button'
                    onClick={clearExpirationDate}
                    className='absolute right-2 top-8 text-gray-500 hover:text-gray-700'
                  >
                    ✕
                  </button>
                )} */}
          {/* </div>
              <div className=''>
                <label className='block text-sm font-medium text-gray-700 text-nowrap'>
                  Days after send:
                </label> */}
          {/* <input
                  type='number'
                  // value={expirationDays}
                  value={formData.messageType === 'text' ? '' : expirationDays}
                  onChange={(e) => handleExpirationDaysChange(e.target.value)}
                  className='w-full p-2 border border-gray-300 rounded'
                  min='1'
                  disabled={formData.messageType !== 'coupon'}
                /> */}
          {/* <input
                  type='text'
                  // value={expirationDays}
                  value={formData.messageType === 'text' ? '' : expirationDays}
                  onChange={(e) => handleExpirationDaysChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Backspace' && expirationDays === '') {
                      e.preventDefault();
                      clearExpirationDate();
                    }
                  }}
                  className='w-full p-2 border border-gray-300 rounded'
                  disabled={formData.messageType !== 'coupon'}
                  min='1'
                /> */}
          {/* <input
                  type='number'
                  min='0'
                  // value={formData.messageType === 'text' ? '' : expirationDays}
                  // onChange={(e) => handleExpirationDaysChange(e.target.value)}
                  className='w-full p-2 border border-gray-300 rounded'
                  disabled={formData.messageType !== 'coupon'}
                />
              </div>
            </div>
          </div> */}
          {formData.messageType === 'coupon' && (
            <div className='mb-4'>
              {/* <label className='block text-sm font-medium text-gray-700'>
              Coupon Expiration:
            </label> */}
              {/* <div className='flex max-sm:flex-wrap gap-2'> */}
              {/* max-sm:flex-wrap gap-1 */}
              <div className='flex flex-col gap-1 w-full'>
                <div className=''>
                  <label className='block text-sm font-medium text-gray-700 text-nowrap'>
                    Coupon Expiration Days (Optional):
                  </label>
                  <input
                    type='number'
                    value={formData.expirationDays}
                    onChange={(e) =>
                      handleInputChange('expirationDays', e.target.value)
                    }
                    onWheel={(e) => e.target.blur()}
                    disabled={formData.messageType !== 'coupon'}
                    className='w-full p-2 border border-gray-300 rounded'
                    min='0'
                    placeholder='No expiration'
                  />
                </div>
                <div className=''>
                  <label className='block text-sm font-medium text-gray-700 text-nowrap'>
                    Coupon Expiration Date:
                  </label>
                  {/* <p className='w-full p-2 border border-gray-300 rounded'>
                  {calculateExpirationDate(
                    formData.expirationDays
                  )?.toLocaleDateString() || ''}
                </p> */}
                  {/* <input
                  type='text'
                  className='w-full p-2 border border-gray-300 rounded'
                  value={
                    calculateExpirationDate(
                      formData.expirationDays
                    )?.toLocaleDateString() || ''
                  }
                  disabled
                /> */}
                  <input
                    type='text'
                    className='w-full p-2 border border-gray-300 rounded'
                    value={
                      calculateExpirationDate(
                        formData.expirationDays,
                        formData.scheduledDate
                      )?.toLocaleDateString() || ''
                    }
                    disabled
                  />
                </div>
              </div>
            </div>
          )}

          {/* ============================ */}
          <div className='mb-4'>
            {action !== 'view' && (
              <>
                <label className='block text-sm font-medium text-gray-700 mb-2'>
                  Upload Image (Optional)
                </label>
                <div
                  {...getRootProps()}
                  className={`dropzone border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors duration-200 ease-in-out ${
                    isDragActive
                      ? 'border-indigo-600 bg-indigo-50'
                      : 'border-gray-300 hover:border-indigo-400'
                  }`}
                >
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <p className='text-indigo-600'>Drop the image here ...</p>
                  ) : (
                    <div>
                      <p className='text-gray-600'>
                        Drag 'n' drop an image here, or click to select one
                      </p>
                      <p className='text-sm text-gray-500 mt-1'>
                        Supported formats: JPG, PNG, GIF
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}
            {formData.image && (
              <div className='mt-2 flex items-center'>
                <span className='text-sm text-gray-600'>
                  {formData.image instanceof File
                    ? formData.image.name
                    : 'Current image'}
                </span>
                <button
                  type='button'
                  onClick={() => handleInputChange('image', null)}
                  className='ml-2 text-red-600 hover:text-red-800 text-sm'
                >
                  Remove
                </button>
              </div>
            )}
            {formData.image && (
              <div className='mt-4'>
                <h3 className='text-lg font-semibold mb-2'>Image Preview</h3>
                <img
                  src={
                    formData.image instanceof File
                      ? URL.createObjectURL(formData.image)
                      : formData.image
                  }
                  alt='Uploaded preview'
                  className='max-w-full h-auto rounded-lg shadow-md'
                />
              </div>
            )}
          </div>
          {error && <p className='text-red-500 mt-2'>{error}</p>}
          {action !== 'view' && (
            <button
              type='submit'
              className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:bg-indigo-300'
              disabled={isSubmitting}
            >
              {isSubmitting
                ? 'Processing...'
                : messageId
                ? messageStatus === 'sent'
                  ? 'Send Again'
                  : 'Update'
                : 'Schedule Message'}
            </button>
          )}
        </form>

        <div className='flex-1 mt-8 md:mt-0'>
          <MessagePreview
            content={formData.content}
            messageType={formData.messageType}
            // expirationDate={formData.expirationDate}
            expirationDate={
              formData.messageType === 'coupon'
                ? calculateExpirationDate(
                    formData.expirationDays,
                    formData.scheduledDate
                  )
                : null
            }
            optOutWord={optOutWord}
            image={formData.image}
            messageId={messageId}
          />

          {/* <CouponPreview
            content={formData.content}
            expirationDays={formData.expirationDays}
            messageType={formData.messageType}
          /> */}
          {formData.messageType === 'coupon' && (
            <>
              {/* <h3 className='text-lg font-semibold mt-8 mb-4'>
                Coupon Preview
              </h3> */}
              <CouponPreview
                content={formData.content}
                // expirationDate={formData.expirationDate}
                expirationDate={
                  formData.messageType === 'coupon'
                    ? calculateExpirationDate(
                        formData.expirationDays,
                        formData.scheduledDate
                      )
                    : null
                }
                messageType={formData.messageType}
              />
            </>
          )}

          {/* {formData.image && (
            <div className='mt-4'>
              <h3 className='text-lg font-semibold mb-2'>Image Preview</h3>
              <img
                src={
                  formData.image instanceof File
                    ? URL.createObjectURL(formData.image)
                    : formData.image
                }
                alt='Uploaded preview'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
}

export default React.memo(TextMessageFormTwoOpti);
